import { useStaticQuery } from "gatsby";
import React from "react";
import { useTranslation } from "react-i18next";
import Departament from "./departament";
import Link from "../../utils/Link";

import "./style.scss";

export const query = graphql`
  query {
    api {
      configContact {
        phoneNumber
        tollFree
        email
      }
    }
  }
`;

const Deparataments = () => {
  const apiData = useStaticQuery(query);
  const { t } = useTranslation();
  const contact = apiData.api.configContact;

  const data = {
    title: t("contact.contacts"),
    items: [
      {
        title: t("contact.contactCenter"),
        subtitle: "",
        items: [
          {
            // subHeader:
            //   "Numri i kontaktit në rast të humbjes/vjedhjes kartës debitit/ kreditit:",
            href: "tel:+08000111",
            text: "0800 0 111",
            subInfo: t("pages.contact.tollFreeDescription"),
          },
          {
            href: "tel:+35542276702",
            text: "(+355 4) 2 276702",
            subInfo: t("pages.contact.phoneNumberDescription"),
          },
          {
            href: "mailto:info@fibank.al",
            text: "info@fibank.al",
            subInfo: (
              <p>
                {t("pages.contact.emailDescription")}{" "}
                <Link to="/tools/client-services">
                  {t("pages.contact.form")}
                </Link>
              </p>
            ),
          },
        ],
      },
      {
        title: t("contact.cardsDepartment"),
        subtitle: "",
        items: [
          {
            subHeader: t("contact.cardsDepartmentDesc"),
            href: "tel:+35542276756",
            text: "(+355 4) 2276 756",
            subInfo: "",
          },
          {
            href: "mailto:cards@fibank.al",
            text: "cards@fibank.al",
            // subHeader: "Adresa e-mail:",
          },
        ],
      },
      {
        title: t("contact.virtualBanking"),
        // subtitle: "Card department 24/7",
        items: [
          {
            subHeader: t("contact.virtualBankingDesc"),
            href: "tel:+35542276723",
            text: "(+355 4) 2276 723",
            // subInfo: "Numri i kontaktit:",
          },
          {
            // subHeader: "Adresa e-mail:",
            href: "mailto:e-banking@fibank.al",
            text: "e-banking@fibank.al",
            subInfo: "",
          },
        ],
      },
    ],
  };

  return (
    <div className="departments-wrap">
      <div className="departments-title">
        <font>
          <font>{data.title}</font>
        </font>
      </div>
      <div className="departments">
        {data.items.map((item) => (
          <Departament {...item} />
        ))}
      </div>
    </div>
  );
};

export default Deparataments;
